import React from 'react';
import styles from './SectionTitle.module.scss';

const SectionTitle = ({ children }) => <h3 className={styles.root}>{children}</h3>;

export default SectionTitle;
